import moment from 'moment';

export function getDateParam(date?: string | null) {
    if (!date) {
        return undefined;
    }

    const startOfDay = moment().utc().startOf('day');
    const dateMoment = moment.utc(date).startOf('day');

    if (dateMoment.isSameOrBefore(startOfDay)) {
        return dateMoment.toISOString();
    }

    return startOfDay.toISOString();
}
